<template>
  <va-modal
    ref="multipleScreeningsModal"
    :value="isOpen"
    :showOkay="false"
    :cancelText="$t('modals.buttons.back')"
    size="medium"
    :fixedLayout="true"
    @cancel="onCancel"
    >

    <div slot="header" class="modal-title">
      {{`${$t('agenda.screenings.page_title')} - ${screeningGroup.facility.name}`}}
    </div>
    <div class="table-responsive">
      <table class="table table-striped first-td-padding">
        <thead>
            <tr>
              <th>{{ $t('agenda.screenings.screening_date') }}</th>
              <th>{{ $t('agenda.screenings.promotor') }}</th>
            </tr>
        </thead>
        <tbody>
            <tr
              v-for="(screening, index) in screeningGroup.screenings"
              :key="index"
              @click="isOpen = false; $emit('updateScreening', screening)"
            >
              <td>{{ getScreeningDate(screening) }}</td>
              <td>{{ getScreeningPromotor(screening) }}</td>
            </tr>
        </tbody>
      </table>
    </div>
  </va-modal>
</template>
<script>
export default {
  props: {
    screeningGroup: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  mounted: function () {
    this.isOpen = true
  },
  methods: {
    getScreeningDate: function (screening) {
      return `${this.$options.filters.localTime(screening.start, 'YYYY-MM-DD HH:mm')} - ${this.$options.filters.localTime(screening.end, 'YYYY-MM-DD HH:mm')}`
    },
    getScreeningPromotor: function (screening) {
      return screening.user ? screening.user.name : $t('agenda.screenings.unassigned_promotor')
    },
    onCancel: function () {
      this.isOpen = false
      this.$emit('modalClosed')
    }
  }
}
</script>

<style lang="scss">
  .table-responsive {
    cursor: pointer;
  }
</style>
